:host {
  display: block;
}

